import React, { useEffect, useRef } from 'react';
import { EditorView, basicSetup } from 'codemirror';
import { EditorState } from '@codemirror/state';
import { sql } from '@codemirror/lang-sql';
import {placeholder} from "@codemirror/view";

const SqlEditor = ({ initialCode = '', onChange, height = '200px' }) => {
    const editorRef = useRef(null);
    const viewRef = useRef(null);

    useEffect(() => {
        if (!editorRef.current) return;

        const updateListener = EditorView.updateListener.of((update) => {
            if (update.docChanged) {
                const newCode = update.state.doc.toString();
                if (onChange) {
                    onChange(newCode);
                }
            }
        });

        const state = EditorState.create({
            doc: initialCode,
            extensions: [placeholder("Write sql query like SELECT * FROM ... or use apimoon AI"), EditorView.lineWrapping, basicSetup, sql(), updateListener],
        });

        viewRef.current = new EditorView({
            state,
            parent: editorRef.current,
            theme: EditorView.theme({
                "&": {height: "100px"},
                ".cm-scroller": {overflow: "auto"}
            }),
        });

        return () => {
            viewRef.current?.destroy();
        };
    }, [initialCode]);

    return <div ref={editorRef} style={{ height: height, width: '100%', overflow: 'auto', border: '1px solid #ccc', background: '#F1FAFE' }} />;
};

export default SqlEditor;
